// extracted by mini-css-extract-plugin
export var comp = "styles-module--comp--1tUEt";
export var compWrap = "styles-module--compWrap--oxt7m";
export var companies = "styles-module--companies--34WK-";
export var csliders = "styles-module--csliders--2Izn6";
export var designElement = "styles-module--designElement--VpZg0";
export var leftDesignElement = "styles-module--leftDesignElement--1m2sl";
export var rightDesignElement = "styles-module--rightDesignElement--1BB2d";